import { render } from "./checkDescrip.vue?vue&type=template&id=d781b7a0&scoped=true&ts=true"
import script from "./checkDescrip.vue?vue&type=script&lang=ts"
export * from "./checkDescrip.vue?vue&type=script&lang=ts"

import "./checkDescrip.vue?vue&type=style&index=0&id=d781b7a0&lang=less&scoped=true"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d781b7a0"]])

export default __exports__